<template>
  <div class="feedback-button-container">
    <button 
      @click="openFeedbackModal" 
      class="feedback-button"
      :aria-label="'Open feedback form'"
    >
      <span class="feedback-icon">💬</span>
      <span class="feedback-text">Feedback</span>
    </button>
    
    <!-- Feedback Modal -->
    <FeedbackModal 
      :isOpen="feedbackModalOpen" 
      @close="feedbackModalOpen = false"
      @submitted="onFeedbackSubmitted"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FeedbackModal from './FeedbackModal.vue';

const feedbackModalOpen = ref(false);

// Open feedback modal
function openFeedbackModal() {
  feedbackModalOpen.value = true;
}

// Handle feedback submission
function onFeedbackSubmitted() {
  // This function can be used if we need to do anything after submission
}
</script>

<style scoped>
.feedback-button-container {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999999;
}

.feedback-button {
  display: flex;
  align-items: center;
  background-color: var(--color-primary-dark);
  color: var(--color-white);
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}

.feedback-button:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.feedback-icon {
  margin-right: 8px;
  font-size: 1.2rem;
}

/* Responsive adjustments */
@media (max-width: 1550px) {
  .feedback-button-container {
    top: 120px;
    right: 20px;
    bottom: auto;
  }
  
  .feedback-button {
    padding: 12px; /* Ensure 44x44 minimum */
    min-width: 44px;
    min-height: 44px;
  }
  
  .feedback-text {
    display: none;
  }
  
  .feedback-icon {
    margin-right: 0;
    font-size: 1.5rem; /* Larger for easier tapping */
  }
}
</style>
